
import './App.css';
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Login from './pages/Login';
import { AuthProvider } from './context/AuthContext';
import HomePage from './pages/HomePage';
import Navbar from './components/Navbar/Navbar';
import Age from './components/Registration/Age';
import CreateFund from './components/Cashfund/CreateFund';
import Home_Dashboard from './pages/Dashboard/Home_Dashboard';
import Funds_Dashboard from './pages/Dashboard/Funds_Dashboard';
import Buddies_Dashboard from './pages/Dashboard/Buddies_Dashboard';
import ProfilePage from './components/Profile/ProfilePage';
import { Bounce, ToastContainer } from 'react-toastify';
import ProfileEditPage from './components/Profile/ProfileEditPage';
import BuddySignUpWizard from './pages/BuddySignUpWizard';
import VerifyEmail from './components/VerifyEmail';
import ChildProfilePage from './pages/ChildProfilePage';


function App() {

  const defaultRouter = createBrowserRouter([

  {
    path: "/login",
    element: <Login />,
  },
  


    {
    path: "/",
    element: <HomePage />, // Placeholder for actual dashboard component
  },
{
    path: "/child/:id",
    element: <ChildProfilePage />, // Placeholder for actual dashboard component
  },

/**
 * Only the ones above are working
 */








    {
    path: "/signup",
    element: <BuddySignUpWizard />, // Placeholder for actual registration component
  },

        {
    path: "/profile",
    element: <ProfilePage />,
  },
       {
    path: "/profile/edit",
    element: <ProfileEditPage />,
  },



  {
    path: "/dashboard/home",
    element: <Home_Dashboard />, // Placeholder for actual dashboard component
  },

  {
    path: "/dashboard/funds",
    element: <Funds_Dashboard />, // Placeholder for actual dashboard component
  },

    {
    path: "/dashboard/buddies",
    element: <Buddies_Dashboard />, // Placeholder for actual dashboard component
  },




   {
    path: "/cashfund/create",
    element: <CreateFund  />  , // Placeholder for actual dashboard component
  },

  {
    path: "/verify-email",
    element: <VerifyEmail  />  , // Placeholder for actual dashboard component
  },
  
]);



  return (
  <div className="App">

       <AuthProvider>
       
         <RouterProvider router={defaultRouter} />
         <ToastContainer
position="top-center"
autoClose={5000}
hideProgressBar={true}
newestOnTop={false}
closeOnClick={false}
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"
transition={Bounce}
/>
       </AuthProvider>
      </div>
  );
}

export default App;
